import { render, staticRenderFns } from "./RequirementsView.vue?vue&type=template&id=f6f4a3f8&scoped=true&"
import script from "./RequirementsView.vue?vue&type=script&lang=js&"
export * from "./RequirementsView.vue?vue&type=script&lang=js&"
import style0 from "./RequirementsView.vue?vue&type=style&index=0&id=f6f4a3f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f4a3f8",
  null
  
)

export default component.exports